import React from 'react';
import { connect, Provider } from 'react-redux';

import { AppState, store, Actions, DisplayWindow, IPageState, } from '../appredux'

import { Paper, Box, Link, WithStyles, MuiThemeProvider } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Theme, withStyles } from "@material-ui/core/styles";

import Zamowienie from './components/Zamowienie';
import Platnosc from './components/Platnosc';
import Kontakt from './components/Kontakt';
import Info from './components/Info';

import CONFIG from '../cfg/config';
import { sendErrorLog } from './common/helpers';
import { config } from 'react-transition-group';
import { ReservationId, bookService, FakturaVatService } from '../api';
import ReactDOM from 'react-dom';

import themeDialog from './../themes-dialog';
import DialogEnd from './dialog/End';
import moment from 'moment';
import ZamowienieFoto from './components/ZamowienieFoto';
import ZamowieniePrzejscie from './components/ZamowieniePrzejscie';
import ZamowienieMenu from './components/ZamowienieMenu';

//PM 2021-11-03
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface BrowseProps extends WithStyles<typeof styles> {
  page: IPageState
  //textTheme: number,

}

class Browse extends React.Component<BrowseProps>  {
  textTheme = {} as React.CSSProperties;

  //PM 2021-11-03
  //(props : BrowseProps)
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  constructor(props: BrowseProps) {
    super(props, {});
    this.updateWindowWidth = this.updateWindowWidth.bind(this);

    if (this.props.page.textTheme === 1) {
      this.textTheme = { fontSize: "0.85rem" }
    }

    sendErrorLog( "1", "1", "ekran glowny")
    store.dispatch(Actions.pageState.addFcmLogMessage("ekran glowny", 0))

    if(CONFIG.rezNr && CONFIG.telNr){
      setTimeout(() => {
        this.openConfirm()
      }, 500);  
    }
  }
  state = {
    //display: 1,
    width: window.innerWidth
  };


  //displayChange = (n: number) => {
  //  this.setState({ ...this.state, display: n });
  //}

  componentDidMount() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  }

  updateWindowWidth() {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  getDayOfWeekFromStringDate = (param: string) => {
    return moment(param.split(' ')[0]).locale("pl").format('YYYY-MM-DD dddd').split(' ')[1];
  }

openConfirm = async() => {
try {

  let [response, fakturaData] = await Promise.all(
    [
      this.sendSuccess(Number(CONFIG.rezNr)),
      FakturaVatService.getHeader({
        hotelId: CONFIG.hotelID,
        dokNr: CONFIG.rezNr
      }, {})
    ]);


  
  if(!fakturaData.result) return

  let adres =  fakturaData.result[0].kontrNazwa.includes(" |") ? fakturaData.result[0].kontrNazwa.split("| ")[1] : fakturaData.result[0].kontrNazwa
  const data = { phone: CONFIG.telNr, address: fakturaData.result[0].kontrNazwa.split("| ")[1], order: Number(CONFIG.rezNr), sum: Number(fakturaData.result[0].brutto), id: Number(CONFIG.rezNr) }
  
  if(fakturaData.result[0].zamFirma === "T"){
    store.dispatch(Actions.pageState.setDostawaDataDzien(fakturaData.result[0].zamData + ' ' + this.getDayOfWeekFromStringDate(fakturaData.result[0].zamData)))

  }
  if (response && response > 0 || fakturaData.result[0].zamkniety.toUpperCase() === "T") {
    
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={themeDialog}>
                <DialogEnd success={true} data={data} paymentId={""} pay_web={this.props.page.contact.payWeb} firma={fakturaData.result[0].zamFirma === "T"} />
            </MuiThemeProvider>
        </Provider>
        , document.getElementById("dialog"));
    await store.dispatch(Actions.pageState.openDialogEnd());


} else {
    //this.sendFailure()
    //this.setState({ open: false })
    ReactDOM.render(

        <Provider store={store}>
            <MuiThemeProvider theme={themeDialog}>
                <DialogEnd success={false} data={data} paymentId={""} pay_web={this.props.page.contact.payWeb} />
            </MuiThemeProvider>
        </Provider>
        , document.getElementById("dialog"));
    await store.dispatch(Actions.pageState.openDialogEnd());
}

} catch (error) {
  console.log(error)
      await sendErrorLog( "0", "-1", 'potwierdzenie zamowienia z linku')
      await store.dispatch(Actions.pageState.addFcmLogMessage("potwierdzenie zamowienia z linku", 2))
}
}

async sendSuccess(dokNr: number) {
  try {
      const res: ReservationId = await bookService.reservConfirm3(
          {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              aDokNr: dokNr,
              aPayWeb: Number(this.props.page.contact.payWeb) // 2
          }, {})
      return res.result[0]
      //console.log(res)  
  } catch (error) {
      console.log(error)
      await sendErrorLog( "0", "-1", '/manager/fakturaKoszykPotwierdz2')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/fakturaKoszykPotwierdz2", 2))
  }
}

  



  //PM 2021-11-03
  //<Zamowienie windowWidth={this.state.width} incPanelRightKey={this.props.incPanelRightKey} />
  selectComponent() {
    if (this.props.page.displayMenu === 1 && CONFIG.kelnerBookFoto === '0') {
      return (
        <Zamowienie windowWidth={this.state.width} />
      )
    } else if (this.props.page.displayMenu === 1 && CONFIG.kelnerBookFoto === '1') {
      return (
        <ZamowienieFoto windowWidth={this.state.width} />
      )
    } else if (this.props.page.displayMenu === 1 && CONFIG.kelnerBookFoto === '2') {
      return (
        <ZamowieniePrzejscie windowWidth={this.state.width} />
      )
    } else if (this.props.page.displayMenu === 1 && CONFIG.kelnerBookFoto === '3') {
      return (
        <ZamowienieMenu windowWidth={this.state.width} />
      )
    } else if (this.props.page.displayMenu === 2) {
      return (
        <Platnosc />
      )
    }
    else if (this.props.page.displayMenu === 3) {
      return (
        <Info />
      )
    }
    else if (this.props.page.displayMenu === 4) {
      return (
        <Kontakt />
      )
    }
  }

  //PM 2021-11-03
  //poprawka klas
  render() {
    const { classes } = this.props;

    return (
      <Paper elevation={3} className={classes.paper}>
        {/* <Box style={{ display: "grid" }}>
          <Box className={classes.header}>
            <Link onClick={() => this.displayChange(1)} className={this.props.display === 1 ? `${classes.active} ${classes.link}` : classes.link} style={this.textTheme}>Zamówienie</Link>
            <Link onClick={() => this.displayChange(2)} className={this.state.display === 2 ? `${classes.active} ${classes.link}` : classes.link} style={this.textTheme}>Płatność</Link>
            <Link onClick={() => store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.History))} className={this.state.display === 5 ? `${classes.active} ${classes.link}` : classes.link} style={this.textTheme}>Historia</Link>

            <Box className={classes.headerRight}>
              <Link onClick={() => this.displayChange(3)} className={this.state.display === 3 ? `${classes.active} ${classes.link}` : classes.link} style={this.textTheme}>Info</Link>
              <Link onClick={() => this.displayChange(4)} className={this.state.display === 4 ? `${classes.active} ${classes.link}` : classes.link} style={this.textTheme}>Kontakt</Link>
            </Box>
            <div className={this.state.display === 1 ? `${classes.bar} ${classes.active1}`
              : this.state.display === 2 ? `${classes.bar} ${classes.active2}`
                : this.state.display === 3 ? `${classes.bar} ${classes.active3}`
                  : this.state.display === 4 ? `${classes.bar} ${classes.active4}`
                    : `${classes.bar} ${classes.active5}`}></div>
          </Box>
        </Box> */}
        <Grid container spacing={0} style={{ padding: "20px", position: "relative" }}>
          {this.selectComponent()}
        </Grid>
      </Paper>
    );
  }
}



const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});


const styles = (theme: Theme) => ({
  paper: {
    padding: "10px",
    border: "1px solid #ccc",
  },
  header: {
    position: "relative" as "relative",
    borderBottom: "1px solid #e0e0e0"
  },
  headerRight: {
    float: "right" as "right",
    [theme.breakpoints.down('sm')]: {
      display: "contents"
    }
  },
  link: {
    [theme.breakpoints.down('xs')]: {
      padding: "15px 0px",
      textAlign: "center",
      width: "25%"
    }
  },
  active: {
    fontWeight: 700,
    //fontSize: "0.85rem"
    "&:hover": {
      color: theme.palette.primary.main,
    }
  },
  bar: {

    [theme.breakpoints.up('lg')]: {
      backgroundColor: theme.palette.secondary.main,
      width: "120px",
      height: "3px",
      left: 0,
      position: "absolute",
      transition: "left .2s ease",
      webkitTransition: "left .2s ease",
    },
    [theme.breakpoints.down('xs')]: {
      backgroundColor: theme.palette.secondary.main,
      width: "25%",
      height: "3px",
      left: 0,
      position: "absolute",
      transition: "left .2s ease",
      webkitTransition: "left .2s ease",
    }

  },
  active1: {
    left: "0px",
  },
  active2: {
    left: "13%",
    [theme.breakpoints.down('xs')]: {
      left: "25%",
    }
  },
  active3: {
    left: "77%",
    [theme.breakpoints.down('xs')]: {
      left: "50%",
    }
  },
  active4: {
    left: "86%",
    [theme.breakpoints.down('xs')]: {
      left: "75%",
    }
  },
  active5: {
    left: "26%",
    [theme.breakpoints.down('xs')]: {
      left: "40%",
    }
  },
});

export default connect(mapStateToProps)(withStyles(styles)(Browse));
